import React, { useState, useCallback, useMemo, useContext } from 'react';
import useContracts from '@ubeya/shared/hooks/account/useContracts';
import { SORT_BY_STRING } from '@ubeya/shared/utils/sorting';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const ContractsFilter = ({ defaultValue, handleClose, onApply, search, onChange, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const { contracts = [] } = useContracts();
  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const filteredOptions = useMemo(() => {
    const noContractOption = { value: 0, label: t('noContractAssigned') };
    const contractOptions = (contracts || []).map((contract) => ({
      value: contract.id,
      label: contract.isDeleted ? `${contract.name} (${t('deleted')})` : contract.name
    }));
    const sorted = [noContractOption, ...contractOptions.sort(SORT_BY_STRING('label'))];
    return search ? sorted.filter(({ label }) => label && label.toLowerCase().includes(search.toLowerCase())) : sorted;
  }, [contracts, search, t]);

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout
      name={t('employeeContract')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`contract-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default ContractsFilter;
